export default {
  title: 'Erhalten Sie die beste Erfahrung mit unserer mobilen App',
  description:
    'Sparen Sie Zeit, verdienen Sie Belohnungen, erhalten Sie Benachrichtigungen über mehr Angebote und mehr',
  buttons: {
    download: 'Öffnen Sie die {{name}} App',
  },
};
